import student2 from "../assets/images/fozil.jpg";

export const studentsData = [
  {
    id: 1,
    name: "Fozilkhon",
    lastName: "Buzrukxo'jayev",
    img: student2,
    grade: '11-"A" ',
    achievments:
      "Shaxmat musobaqasida shaharda faxrli õrinni egallagan, IELTS B2 sohibi, kõplab olimpiadalar ģolibi va dreamsat, skillscamp a'zosi",
  },
  {
    id: 2,
    name: "Abdullokh",
    lastName: "Niģmatullayev",
    img: student2,
    grade: '10-"J" ',
    achievments:
      "FrontEnd dasturchi, Dreamsat va IbratCamp a'zosi hamda informatika olimpiadalari ģolibi",
  },
  {
    id: 3,
    name: "Odina",
    lastName: "Saidnazarova",
    img: student2,
    grade: '11-"A" ',
    achievments:
      "Qizil attestat va IELTS B2 sohibasi, mening huquq va majburiyatlarim tanlovida respublika 4 õrin ģolibasi, yoshlar ittifoqi ta'lim sardori va dreamsat, technoCamp a'zosi",
  },
  {
    id: 4,
    name: "Umida",
    lastName: "Xurramova",
    img: student2,
    grade: '11-"A" ',
    achievments:
      "Qizil attestat sohibasi va dreamsat a'zosi, sport bõyicha kõplab musobaqalar ģolibasi",
  },
  {
    id: 5,
    name: "Sevinch",
    lastName: "Azimova",
    img: student2,
    grade: '11-"D" ',
    achievments:
      " IELTS 8 sohibasi, kõplab tadbirlar va kõrik tanlovlar ģolibasi, dreamsat a'zosi",
  },
  {
    id: 6,
    name: "Risolat",
    lastName: "Qutpillayeva",
    img: student2,
    grade: '11-"A" ',
    achievments:
      " Yosh kitobxon tanlovida tumanda 2 õrin ģolibasi, balli qizlar kõrik tanlovining ģolibasi",
  },
  {
    id: 7,
    name: "Sevinch",
    lastName: "Azimova",
    img: student2,
    grade: '11-"D" ',
    achievments:
      " IELTS 8 sohibasi, kõplab tadbirlar va kõrik tanlovlar ģolibasi, dreamsat a'zosi",
  },
  {
    id: 8,
    name: "Risolat",
    lastName: "Qutpillayeva",
    img: student2,
    grade: '11-"A" ',
    achievments:
      " Yosh kitobxon tanlovida tumanda 2 õrin ģolibasi, balli qizlar kõrik tanlovining ģolibasi",
  },
];
